import { render, staticRenderFns } from "./EditSubGoal.vue?vue&type=template&id=415e57ed"
import script from "./EditSubGoal.vue?vue&type=script&lang=js"
export * from "./EditSubGoal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports